import React from 'react';
import PropTypes from 'prop-types';
import pathfinder from '@fiverr-private/pathfinder';
import './style.scss';

const RenderName = ({ userName }) => (
    <b className="seller-link">{userName}</b>
);

RenderName.propTypes = {
    userName: PropTypes.string.isRequired
};

const RenderNameWithLink = ({ userName, link, onUsernameClick }) => (
    <a href={link} className="seller-link" onClick={onUsernameClick}>{userName}</a>
);

RenderNameWithLink.propTypes = {
    userName: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    onUsernameClick: PropTypes.func
};

/**
 * @function
 * @name ProfileLink
 * @param {String} userName - the user's name
 * @param {String} link - link string
 * @param {Boolean} noLink - text only, don't make it a link
 * @param {Function} onUsernameClick - a callback function for username click
 * Returns the markup of the user profile link
 */

const ProfileLink = ({ userName, link, noLink, onUsernameClick }) => (
    noLink ?
        <RenderName userName={userName}/> :
        <RenderNameWithLink userName={userName}
            link={link ? link : pathfinder('short_user', { id: userName })}
            onUsernameClick={onUsernameClick}/>
);

ProfileLink.propTypes = {
    userName: PropTypes.string.isRequired,
    link: PropTypes.string,
    noLink: PropTypes.bool,
    onUsernameClick: PropTypes.func
};

export default ProfileLink;
